import gsap from 'gsap';

/**
 * GSAP timeline manager (prepared only). Centralizes a master timeline plus
 * named sub-timelines so future camera / object / material / scroll animations
 * register here instead of scattering GSAP calls across the codebase.
 *
 * No animations are authored in Phase 01.
 *
 * Future ScrollTrigger wiring (when sections exist):
 *   ScrollTrigger.scrollerProxy + `lenis.on('scroll', ScrollTrigger.update)`.
 */
export class AnimationManager {
  readonly gsap = gsap;
  readonly master: gsap.core.Timeline;
  private readonly timelines = new Map<string, gsap.core.Timeline>();

  constructor() {
    this.master = gsap.timeline();
  }

  create(name: string, vars?: gsap.TimelineVars): gsap.core.Timeline {
    const timeline = gsap.timeline(vars);
    this.timelines.set(name, timeline);
    return timeline;
  }

  get(name: string): gsap.core.Timeline | undefined {
    return this.timelines.get(name);
  }

  kill(name: string): void {
    this.timelines.get(name)?.kill();
    this.timelines.delete(name);
  }

  pauseAll(): void {
    this.master.pause();
    this.timelines.forEach((timeline) => timeline.pause());
  }

  resumeAll(): void {
    this.master.resume();
    this.timelines.forEach((timeline) => timeline.resume());
  }

  dispose(): void {
    this.timelines.forEach((timeline) => timeline.kill());
    this.timelines.clear();
    this.master.kill();
  }
}
